<template>
  <div>
    <v-parallax
      height="100"
      dark
      src="https://cdn.vuetifyjs.com/images/backgrounds/vbanner.jpg"
    >
      <div>
        <v-row align="center" justify="center">
          <router-link class="back" to="/"
            ><v-btn x-large icon
              ><v-icon color="white">mdi-arrow-left</v-icon></v-btn
            ></router-link
          >
          <v-col class="text-center" cols="12">
            <div class="text-h4 font-weight-thin">Impressum</div>
          </v-col>
        </v-row>
      </div>
    </v-parallax>
    <div class="impress-text">
      <v-sheet>
        <p>Angaben gemäß § 5 TMG:<br /><br /></p>
        <p>
          Foto Nova GmbH<br />
          Stuttgarter Str. 19<br />
          71665 Vaihingen/Enz<br />
        </p>
        <h2>Vertreten durch:</h2>
        <p>Günter Lämmle</p>
        <h2>Kontakt:</h2>
        <table>
          <tr>
            <td><p>Telefon:</p></td>
            <td><p>07042-15777</p></td>
          </tr>
          <tr>
            <td><p>Telefax:</p></td>
            <td><p>07042-13740</p></td>
          </tr>
          <tr>
            <td><p>E-Mail:</p></td>
            <td><p>mail@fotonova.de</p></td>
          </tr>
        </table>
        <h2>Registereintrag:</h2>
        <p>
          Eintragung im Handelsregister. <br />Registergericht:Stuttgart
          <br />Registernummer: 290512
        </p>
        <h2>Umsatzsteuer-ID:</h2>
        <p>
          Umsatzsteuer-Identifikationsnummer gemäß §27 a Umsatzsteuergesetz:<br />
          D144995419
        </p>
        <p></p>

        <h2>Haftungsausschluss:</h2>
        <p><strong>Haftung für Inhalte</strong></p>
        <p>
          Die Inhalte unserer Seiten wurden mit größter Sorgfalt erstellt. Für
          die Richtigkeit, Vollständigkeit und Aktualität der Inhalte können wir
          jedoch keine Gewähr übernehmen. Als Diensteanbieter sind wir gemäß § 7
          Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen
          Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als
          Diensteanbieter jedoch nicht verpflichtet, übermittelte oder
          gespeicherte fremde Informationen zu überwachen oder nach Umständen zu
          forschen, die auf eine rechtswidrige Tätigkeit hinweisen.
          Verpflichtungen zur Entfernung oder Sperrung der Nutzung von
          Informationen nach den allgemeinen Gesetzen bleiben hiervon unberührt.
          Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der
          Kenntnis einer konkreten Rechtsverletzung möglich. Bei Bekanntwerden
          von entsprechenden Rechtsverletzungen werden wir diese Inhalte
          umgehend entfernen.
        </p>
        <p><strong>Haftung für Links</strong></p>
        <p>
          Unser Angebot enthält Links zu externen Webseiten Dritter, auf deren
          Inhalte wir keinen Einfluss haben. Deshalb können wir für diese
          fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der
          verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der
          Seiten verantwortlich. Die verlinkten Seiten wurden zum Zeitpunkt der
          Verlinkung auf mögliche Rechtsverstöße überprüft. Rechtswidrige
          Inhalte waren zum Zeitpunkt der Verlinkung nicht erkennbar. Eine
          permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne
          konkrete Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei
          Bekanntwerden von Rechtsverletzungen werden wir derartige Links
          umgehend entfernen.
        </p>
        <p><strong>Urheberrecht</strong></p>
        <p>
          Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen
          Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung,
          Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der
          Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des
          jeweiligen Autors bzw. Erstellers. Downloads und Kopien dieser Seite
          sind nur für den privaten, nicht kommerziellen Gebrauch gestattet.
          Soweit die Inhalte auf dieser Seite nicht vom Betreiber erstellt
          wurden, werden die Urheberrechte Dritter beachtet. Insbesondere werden
          Inhalte Dritter als solche gekennzeichnet. Sollten Sie trotzdem auf
          eine Urheberrechtsverletzung aufmerksam werden, bitten wir um einen
          entsprechenden Hinweis. Bei Bekanntwerden von Rechtsverletzungen
          werden wir derartige Inhalte umgehend entfernen.
        </p>
        <p><strong>Datenschutz</strong></p>
        <p>
          Die Nutzung unserer Webseite ist in der Regel ohne Angabe
          personenbezogener Daten möglich. Soweit auf unseren Seiten
          personenbezogene Daten (beispielsweise Name, Anschrift oder
          eMail-Adressen) erhoben werden, erfolgt dies, soweit möglich, stets
          auf freiwilliger Basis. Diese Daten werden ohne Ihre ausdrückliche
          Zustimmung nicht an Dritte weitergegeben.
        </p>
        <p>
          Wir weisen darauf hin, dass die Datenübertragung im Internet (z.B. bei
          der Kommunikation per E-Mail) Sicherheitslücken aufweisen kann. Ein
          lückenloser Schutz der Daten vor dem Zugriff durch Dritte ist nicht
          möglich.
        </p>
        <p>
          Der Nutzung von im Rahmen der Impressumspflicht veröffentlichten
          Kontaktdaten durch Dritte zur Übersendung von nicht ausdrücklich
          angeforderter Werbung und Informationsmaterialien wird hiermit
          ausdrücklich widersprochen. Die Betreiber der Seiten behalten sich
          ausdrücklich rechtliche Schritte im Falle der unverlangten Zusendung
          von Werbeinformationen, etwa durch Spam-Mails, vor.
        </p>
        <p></p>

        <p></p>
        <p>
          <i
            >Quellen:
            <a
              href="http://www.e-recht24.de/muster-disclaimer.htm"
              target="_blank"
              >eRecht24 Disclaimer</a
            >,
            <a
              href="http://www.e-recht24.de/artikel/datenschutz/6590-facebook-like-button-datenschutz-disclaimer.html"
              target="_blank"
              >Facebook Disclaimer von eRecht24</a
            >,
            <a
              href="http://www.google.com/intl/de_ALL/analytics/tos.html"
              target="_blank"
              >Google Analytics Datenschutzerklärung</a
            ></i
          >
        </p>

        <p>
          Quelle:
          <i
            >Durch den vom
            <a
              href="http://www.e-recht24.de/impressum-generator.html"
              target="_blank"
              >Rechtsanwalt</a
            >
            Sören Siebert bereitgestellten Impressum-Generator generiert.</i
          >
        </p>
      </v-sheet>
    </div>
  </div>
</template>

<script>
export default {
  mounted() {
    window.scrollTo(0, 0);
  },
};
</script>

<style>
.impress-text {
  padding-top: 2rem;
  padding-left: 2rem;
  padding-right: 2rem;
}
</style>